import React from 'react';
import CustomModalDialog from '../../../../components/CustomDialog';

export default function ConfirmModifyModal(props) {
  const { showModal, onConfirm, onCancel } = props;
  return (
    <CustomModalDialog
      showModal={showModal}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <div className="cancel-order-content">
        提交成功后，将会取消当前的预约单，是否确定修改并提交新预约单
      </div>
    </CustomModalDialog>
  )
}
